<form *ngIf="configurationFormGroup" [formGroup]="configurationFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-4 input-field">
                <label>Grupo *</label>
                <input pInputText formControlName="group" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label>Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label>Código</label>
                <input pInputText formControlName="code" d-form-field-error />
            </div>
            <div class="col-8 input-field">
                <label>Descripción</label>
                <input pInputText formControlName="description" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label>Valor</label>
                <input pInputText formControlName="value" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label>Tipo de dato</label>
                <p-dropdown formControlName="dataType" [options]="dataTypeOptions" optionLabel="label" optionValue="value"
                    placeholder="Seleccione..." showClear styleClass="w-full" d-form-field-error>
                </p-dropdown>
            </div>
            <div class="col-3 input-field">
                <label>Tipo de control</label>
                <p-dropdown formControlName="controlType" [options]="controlTypeOptions" optionLabel="label" optionValue="value"
                    placeholder="Seleccione..." showClear styleClass="w-full" d-form-field-error>
                </p-dropdown>
            </div>
            <div class="col-3 input-field">
                <label>Visible</label>
                <p-checkbox formControlName="visible" [binary]="true" d-form-field-error></p-checkbox>
            </div>
            <div class="col-3 input-field">
                <label>Sistema</label>
                <p-checkbox formControlName="system" [binary]="true" d-form-field-error></p-checkbox>
            </div>
            <div class="col-12 input-field">
                <label>Configuración (JSON)</label>
                <textarea pInputTextarea formControlName="configuration" [rows]="5" class="w-full font-monospace"
                    placeholder='{ "data": [{ "value": "yes", "text": "Sí" }] }' d-form-field-error></textarea>
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>
